"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(items) {
  return items.map(function (_ref) {
    var skuId = _ref.id,
        skuCode = _ref.sku,
        _ref$product = _ref.product,
        _ref$product$name = _ref$product.name,
        name = _ref$product$name === void 0 ? null : _ref$product$name,
        id = _ref$product.id,
        category = _ref$product.category,
        subCategory = _ref$product.subCategory,
        listPrice = _ref$product.listPrice,
        stockLevel = _ref$product.stockLevel,
        colour = _ref$product.colour,
        brands = _ref$product.brands,
        division = _ref$product.division,
        isMarkedDown = _ref$product.isMarkedDown,
        quantity = _ref.quantity,
        size = _ref.size;
    return _objectSpread(_objectSpread(_objectSpread({}, name && {
      name: name
    }), {}, {
      skuId: skuId,
      skuCode: skuCode,
      id: id,
      division: division,
      category: category,
      subcategory: subCategory,
      price: listPrice,
      isMarkedDown: isMarkedDown,
      quantity: quantity,
      stock: stockLevel.toString(),
      colour: colour,
      size: size
    }, brands && {
      brands: brands
    }), {}, {
      variantId: skuId.split(',')[1] || null
    });
  });
};

exports["default"] = _default;